
import Vue from 'vue'
import {
  Button,
  Collapse,
  CollapseItem,
  DatePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Form,
  FormItem,
  Icon,
  Input,
  Option,
  Select
} from 'element-ui'

Vue.use(Button)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Option)
Vue.use(Select)
